import { createAsyncThunk } from '@reduxjs/toolkit'
import { APIError, authenticatedRequest, getExceptionPayload } from '../axiosConfiguration'
import {
  OrderTrackingData,
  OrderTrackingRequest,
  OrderTrackingFilter,
  OrderTrackingDocuments,
} from '../type/orderTracking'
import * as layoutActions from './layout'
import { create } from 'domain'
import format from 'date-fns/format'

export const getOrderTrackingList =
  createAsyncThunk<OrderTrackingData, OrderTrackingRequest, {
    rejectValue: APIError
  }>(
    '/order-tracking',
    async (query, { dispatch, rejectWithValue }) => {
      dispatch(layoutActions.startLoading())

      try {
        const instance = await authenticatedRequest()
        const queryParams = new URLSearchParams()
        const currentLanguage = localStorage.getItem('selectedLanguage') ?? 'en'
        queryParams.append('language_code', currentLanguage)
        if (query.filter.companyCode) {
          queryParams.append('company_code', query.filter.companyCode.toString())
        }
        if (query.filter.customerCode) {
          queryParams.append('customer_code', query.filter.customerCode.toString())
        }
        if (query.filter.promisedDateFrom) {
          queryParams.append('from_date', format(query.filter.promisedDateFrom as Date, 'yyyy-MM-dd'))
        }


        if (query.filter.promisedDateTo) {
          queryParams.append('from_date', format(query.filter.promisedDateTo as Date, 'yyyy-MM-dd'))
        }

        const res = await instance.get<OrderTrackingData>(`/order?${queryParams.toString()}`)

        dispatch(layoutActions.endLoading())

        return res.data
      } catch (error) {
        const err = getExceptionPayload(error, 'orderTracking:error.getOrderTrackingList')
        console.log(err)
        dispatch(layoutActions.endLoading())
        dispatch(layoutActions.showToast({ summary: err.message, severity: 'error' }))

        return rejectWithValue(err)
      }
    },
  )

export const getOrderTrackingDocument =
  createAsyncThunk<OrderTrackingDocuments, OrderTrackingFilter, {
    rejectValue: APIError
  }>(
    '/order-tracking/get-document',
    async (query, { dispatch, rejectWithValue }) => {
      dispatch(layoutActions.startLoading())

      try {
        const instance = await authenticatedRequest()
        const queryParams = new URLSearchParams()
        queryParams.append('company_code', query.companyCode.toString())
        queryParams.append('customer_code', query.customerCode.toString())
        queryParams.append('order_number', query.orderNumber.toString())
        const res = await instance.get<OrderTrackingDocuments>(`/order/get-document?${queryParams.toString()}`) //, requestPayload)

        dispatch(layoutActions.endLoading())

        return res.data
      } catch (error) {
        const err = getExceptionPayload(error, `orderTracking:error.getOrderTrackingDocument`, { orderNumber: query.orderNumber })
        console.log(err)
        dispatch(layoutActions.endLoading())
        dispatch(layoutActions.showToast({ summary: err.message, severity: 'error' }))

        return rejectWithValue(err)
      }
    },
  )